import React from "react";
import HeroCopy from "./HeroCopy";
import HeroChartCard from "./HeroChartCard";

const HERO_BG =
    "https://static.prod-images.emergentagent.com/jobs/51f38290-0410-404e-b160-085423ca1b2a/images/57dc5c62d1de80a17cbfeb075375e4ea1b2f8e7bd4a14c615e3e3d4895a6d822.png";

export default function Hero() {
    return (
        <section
            data-testid="hero-section"
            className="relative pt-32 lg:pt-40 pb-20 overflow-hidden"
        >
            <div className="absolute inset-0 -z-10">
                <img
                    src={HERO_BG}
                    alt=""
                    className="w-full h-full object-cover opacity-40"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-[#050814]/80 via-[#050814]/85 to-[#050814]" />
                <div className="absolute inset-0 xpo-grid-bg opacity-50" />
            </div>

            <div className="absolute top-32 -left-20 w-96 h-96 xpo-glow-mint -z-10 blur-3xl" />
            <div className="absolute bottom-0 right-0 w-[500px] h-[500px] xpo-glow-navy -z-10 blur-3xl" />

            <div className="xpo-container relative">
                <div className="grid lg:grid-cols-12 gap-12 items-center">
                    <HeroCopy />
                    <HeroChartCard />
                </div>
            </div>
        </section>
    );
}
